import { doGetRequest } from "../../shared/api/base-api";
import common from "../../shared/common";
import { apiUrl } from "../../shared/constants";

// Module quiz report details api
export function moduleQuizReport(data) {
   return doGetRequest(common.stringformat(apiUrl.moduleQuizReport, data));
}

